var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-map-popup"},[_c('InfoWindow',{ref:"infoWindow",attrs:{"title":_vm.label,"address":_vm.address}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }